// extracted by mini-css-extract-plugin
export default {"wrap":"ChangeLanguage_wrap__B8J+D","flag":"ChangeLanguage_flag__jnrf4"};